
import React, { useEffect } from 'react';
import ScanLines from '../components/ScanLines';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Work from '../components/Work';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Index = () => {
  useEffect(() => {
    // Change title
    document.title = 'SpecialAgentK | Secure Digital Operations';
  }, []);

  return (
    <div className="bg-cyber-black text-cyber-green min-h-screen">
      <ScanLines />
      <Header />
      <Hero />
      <About />
      <Work />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
